import axios from "axios";
import {
  AccountType,
  AffOp,
  ContactType,
  EdaOp,
  IhaOp,
  ReportOp,
  S3FetchOp,
  S3Op,
} from "./constants";

// make env variables:
// baseUrl, x-api-key
const baseURL = "https://4jd9u0hdb0.execute-api.us-west-2.amazonaws.com/prod";
const API = axios.create({ baseURL });

API.interceptors.request.use((req) => {
  req.headers["x-api-key"] = "FAGWfuSJRT6fWOV4Mw03c4bWaMchO66p1gbi6zOs";
  // if (localStorage.getItem('profile')) {
  //     req.headers.Authorization = `Bearer ${JSON.parse(localStorage.getItem('profile'))["token"]}`;
  // }
  return req;
});

const logAndReq = (path, params) => {
  console.log("request", path, params);
  return API.post(path, params);
};

export const register = ({
  firstName,
  lastName,
  contactInfo,
  password,
  referralCode,
  ip,
  contactType = ContactType.email,
  accountType = AccountType.standard,
}) =>
  logAndReq("/register", {
    first_name: firstName,
    last_name: lastName,
    contact_info: contactInfo,
    password,
    referral_code: referralCode,
    ip,
    contact_type: contactType,
    account_type: accountType,
  });
export const submitSurvey = ({
  contactInfo,
  contactType,
  loginToken,
  ...survey
}) =>
  logAndReq("/submit_survey", {
    contact_info: contactInfo,
    contact_type: contactType,
    login_token: loginToken,
    ...survey,
  });
export const login = ({ contactInfo, contactType, password, stayLoggedIn }) =>
  logAndReq("/login", {
    contact_info: contactInfo,
    contact_type: contactType,
    password,
    stay_logged_in: stayLoggedIn,
  });
export const verify = ({ contactInfo, contactType, loginToken, accountType }) =>
  logAndReq("/verify", {
    contact_info: contactInfo,
    contact_type: contactType,
    login_token: loginToken,
    account_type: accountType,
  });
export const surveyData = ({ contactInfo, contactType, loginToken }) =>
  logAndReq("/survey_data", {
    contact_info: contactInfo,
    contact_type: contactType,
    login_token: loginToken,
  });
export const getJobs = ({
  contactInfo,
  contactType,
  loginToken,
  jobToken,
  appToken,
}) =>
  logAndReq("/get_jobs", {
    contact_info: contactInfo,
    contact_type: contactType,
    login_token: loginToken,
    job_token: jobToken,
    app_token: appToken,
  });
export const getEdu = ({ tag, skipCount }) =>
  logAndReq("/get_edu", {
    tag,
    skip_count: skipCount,
  });
export const getEduById = ({ eduId }) =>
  logAndReq("/get_edu", {
    edu_id: eduId,
  });
export const toggleFavJob = ({
  contactInfo,
  contactType,
  loginToken,
  jobId,
  isFav,
}) =>
  logAndReq("/toggle_fav_job", {
    contact_info: contactInfo,
    contact_type: contactType,
    login_token: loginToken,
    job_id: jobId,
    is_fav: isFav,
  });
export const updateSettings = ({
  contactInfo,
  contactType,
  loginToken,
  settings,
}) =>
  logAndReq("/update_settings", {
    contact_info: contactInfo,
    contact_type: contactType,
    login_token: loginToken,
    settings,
  });
export const updatePassword = ({
  contactInfo,
  contactType,
  currentPassword,
  newPassword,
  confirmNewPassword,
}) =>
  logAndReq("/update_password", {
    contact_info: contactInfo,
    contact_type: contactType,
    current_password: currentPassword,
    new_password: newPassword,
    confirm_new_password: confirmNewPassword,
  });
export const deleteAccount = ({ contactInfo, contactType, loginToken }) =>
  logAndReq("/delete_account", {
    contact_info: contactInfo,
    contact_type: contactType,
    login_token: loginToken,
  });
export const requestResetPassword = ({ contactInfo }) =>
  logAndReq("/request_reset_password", {
    contact_info: contactInfo,
  });
export const resetPassword = ({ contactInfo, token, newPassword }) =>
  logAndReq("/reset_password", {
    contact_info: contactInfo,
    token,
    new_password: newPassword,
  });
export const requestVerifyEmail = ({ contactInfo, contactType }) =>
  logAndReq("/request_verify_email", {
    contact_info: contactInfo,
    contact_type: contactType,
  });
export const verifyEmail = ({ contactInfo, token }) =>
  logAndReq("/verify_email", {
    contact_info: contactInfo,
    token,
  });
export const unsubscribe = ({ contactInfo, token }) =>
  logAndReq("/unsubscribe", {
    contact_info: contactInfo,
    token,
  });
export const getApplyData = ({ contactInfo, contactType, loginToken, jobId }) =>
  logAndReq("/get_apply_data", {
    contact_info: contactInfo,
    contact_type: contactType,
    login_token: loginToken,
    job_id: jobId,
  });
export const jobClick = ({
  contactInfo,
  contactType,
  loginToken,
  jobId,
  clickType,
}) =>
  logAndReq("/job_click", {
    contact_info: contactInfo,
    contact_type: contactType,
    login_token: loginToken,
    job_id: jobId,
    click_type: clickType,
  });
export const eduClick = ({
  contactInfo,
  contactType,
  loginToken,
  eduId,
  clickType,
}) =>
  logAndReq("/edu_click", {
    contact_info: contactInfo,
    contact_type: contactType,
    login_token: loginToken,
    edu_id: eduId,
    click_type: clickType,
  });

export const adminSurveyData = ({
  contactInfo,
  contactType,
  loginToken,
  targetContactInfo,
  targetContactType,
}) =>
  logAndReq("/admin", {
    contact_info: contactInfo,
    contact_type: contactType,
    login_token: loginToken,
    target_contact_info: targetContactInfo,
    target_contact_type: targetContactType,
    op: "get_survey_data",
  });

export const logAffiliateLanded = ({ token, ip, isNewRef }) =>
  logAndReq("/aff", {
    op: AffOp.landed,
    token,
    ip,
    is_new_ref: isNewRef,
  });
export const uploadResume = ({
  contactInfo,
  contactType,
  loginToken,
  fileName,
  filePath,
  fileData,
}) => {
  const params = new FormData();
  const path = "/upload_resume";
  params.append("contact_info", contactInfo);
  params.append("contact_type", contactType);
  params.append("login_token", loginToken);
  params.append("file_name", fileName);
  params.append("file_path", filePath);
  params.append("file_data", fileData);

  return API.post(path, params, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
export const testUpload = ({ fileData }) => {
  const params = new FormData();
  const path = "/test_upload";
  console.log("upload w/ data", fileData);
  params.append("file_data", fileData);

  return API.post(path, params);
};
export const getResumeUploads = ({ contactInfo, contactType, loginToken }) =>
  logAndReq("/get_resume_uploads", {
    contact_info: contactInfo,
    contact_type: contactType,
    login_token: loginToken,
  });
export const getResume = ({ contactInfo, contactType, loginToken, resumeId }) =>
  logAndReq("/iha", {
    contact_info: contactInfo,
    contact_type: contactType,
    login_token: loginToken,
    resume_id: resumeId,
    op: IhaOp.getResume,
  });
export const getNumUnread = ({ contactInfo, contactType, loginToken }) =>
  logAndReq("/iha", {
    contact_info: contactInfo,
    contact_type: contactType,
    login_token: loginToken,
    op: IhaOp.getNumUnread,
  });
export const submitApplication = ({
  contactInfo,
  contactType,
  loginToken,
  application,
  jobId,
}) =>
  logAndReq("/submit_application", {
    contact_info: contactInfo,
    contact_type: contactType,
    login_token: loginToken,
    application,
    job_id: jobId,
  });
// get_resume_uploads

// logAndReq("/upload_resume", {
//   contact_info: contactInfo,
//   contact_type: contactType,
//   login_token: loginToken,
//   file_name: fileName,
//   file_path: filePath,
//   file_data: fileData,
// });

export const getChats = ({ contactInfo, contactType, loginToken, latestId }) =>
  logAndReq("/iha", {
    contact_info: contactInfo,
    contact_type: contactType,
    login_token: loginToken,
    latest_id: latestId,
    op: IhaOp.getChats,
  });
export const getFullChat = ({
  contactInfo,
  contactType,
  loginToken,
  recruiterId,
  latestId,
}) =>
  logAndReq("/iha", {
    contact_info: contactInfo,
    contact_type: contactType,
    login_token: loginToken,
    recruiter_id: recruiterId,
    latest_id: latestId,
    op: IhaOp.getFullChat,
  });
export const getApplicationData = ({
  contactInfo,
  contactType,
  loginToken,
  applicationId,
}) =>
  logAndReq("/iha", {
    contact_info: contactInfo,
    contact_type: contactType,
    login_token: loginToken,
    application_id: applicationId,
    op: IhaOp.getApplicationData,
  });
export const getAllApplicationData = ({
  contactInfo,
  contactType,
  loginToken,
}) =>
  logAndReq("/iha", {
    contact_info: contactInfo,
    contact_type: contactType,
    login_token: loginToken,
    op: IhaOp.getAllApplicationData,
  });
export const messageBasic = ({
  contactInfo,
  contactType,
  loginToken,
  recruiterId,
  message,
}) =>
  logAndReq("/iha", {
    contact_info: contactInfo,
    contact_type: contactType,
    login_token: loginToken,
    recruiter_id: recruiterId,
    message,
    op: IhaOp.messageBasic,
  });
export const getSchools = ({ contactInfo, contactType, loginToken }) =>
  logAndReq("/iha", {
    contact_info: contactInfo,
    contact_type: contactType,
    login_token: loginToken,
    op: IhaOp.getSchools,
  });
export const addSchool = ({
  contactInfo,
  contactType,
  loginToken,
  schoolData,
}) =>
  logAndReq("/iha", {
    contact_info: contactInfo,
    contact_type: contactType,
    login_token: loginToken,
    school_data: schoolData,
    op: IhaOp.addSchool,
  });
export const updateSchool = ({
  contactInfo,
  contactType,
  loginToken,
  schoolId,
  schoolData,
}) =>
  logAndReq("/iha", {
    contact_info: contactInfo,
    contact_type: contactType,
    login_token: loginToken,
    school_id: schoolId,
    school_data: schoolData,
    op: IhaOp.updateSchool,
  });
export const deleteSchool = ({
  contactInfo,
  contactType,
  loginToken,
  schoolId,
}) =>
  logAndReq("/iha", {
    contact_info: contactInfo,
    contact_type: contactType,
    login_token: loginToken,
    school_id: schoolId,
    op: IhaOp.deleteSchool,
  });
export const getOwnProfilePic = ({ contactInfo, contactType, loginToken }) =>
  logAndReq("/s3f", {
    contact_info: contactInfo,
    contact_type: contactType,
    login_token: loginToken,
    op: S3FetchOp.get_own_profile_pic,
  });
export const deleteOwnProfilePic = ({ contactInfo, contactType, loginToken }) =>
  logAndReq("/s3f", {
    contact_info: contactInfo,
    contact_type: contactType,
    login_token: loginToken,
    op: S3FetchOp.delete_own_profile_pic,
  });
export const uploadProfilePic = ({
  contactInfo,
  contactType,
  loginToken,
  fileData,
  fileName,
  scale,
}) => {
  const params = new FormData();
  const path = "/s3u";
  params.append("op", S3Op.upload_profile_pic);
  params.append("contact_info", contactInfo);
  params.append("contact_type", contactType);
  params.append("login_token", loginToken);
  params.append("file_data", fileData);
  params.append("file_name", fileName);
  params.append("scale", scale);

  return API.post(path, params, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
export const getCompanyInfoByJobId = ({ jobId }) => {
  return logAndReq("/hire", {
    job_id: jobId,
    op: EdaOp.getCompanyInfo,
  });
};
export const applicantgetRecruiterProfilePic = ({
  contactInfo,
  contactType,
  loginToken,
  recruiterId,
}) =>
  logAndReq("/s3f", {
    contact_info: contactInfo,
    contact_type: contactType,
    login_token: loginToken,
    recruiter_id: recruiterId,
    op: S3FetchOp.applicant_get_recruiter_profile_pic,
  });
export const reportJob = ({
  contactInfo,
  contactType,
  loginToken,
  jobId,
  title,
  comments,
  hide,
}) =>
  logAndReq("/report", {
    contact_info: contactInfo,
    contact_type: contactType,
    login_token: loginToken,
    job_id: jobId,
    title,
    comments,
    hide,
    op: ReportOp.reportJob,
  });
